import $ from 'jquery';

(function initialize() {
  $.fn.injectForm = function injectForm(html) {
    // eslint-disable-next-line security/no-html-method
    return this.html(html)
      .promise()
      .done(function handleDone() {
        $('[autofocus]').focus();
      });
  };
})();
